import type { LocaleType } from "@crescentapplications/react-ui";

const AboutAhmadLocales: LocaleType = {
  period: {
    ar: ".",
    en: ".",
  },
  comma: {
    ar: "،",
    en: ",",
  },
  and: {
    ar: "و",
    en: "and ",
  },

  pageTitle: {
    ar: "أحمد الجمل",
    en: "Ahmad El Gamal",
  },
  title: {
    ar: "أحمد الجمل",
    en: "Ahmad El Gamal",
  },
  profile: {
    ar: "الملف الشخصي",
    en: "Profile",
  },
  biography: {
    ar: "السيرة الذاتية",
    en: "Biography",
  },
  biographyText1: {
    ar: "أحمد الجمل رجل أعمال وإمام ومربٍّ ذو خلفية متعددة التخصصات تجمع بين الهندسة، والعلوم الإسلامية، والتكنولوجيا. حاصل على بكالوريوس في الهندسة المدنية من جامعة كولورادو بولدر، وليسانس في العلوم الإسلامية والعربية من جامعة الأزهر، وشهادة تطوير تطبيقات شبكة المعلومات من جامعة كاليفورنيا بركلي.",
    en: "Ahmad El Gamal is an entrepreneur, imam, and educator with a multidisciplinary background spanning engineering, Islamic sciences, and technology. He holds a B.S. in Civil Engineering from the University of Colorado Boulder, a B.A. in Islamic and Arabic Sciences from Al‑Azhar University, and a Full‑Stack Web Development Certificate from the University of California, Berkeley Extension.",
  },
  biographyText2: {
    ar: "أسس مدرسة الرؤية الجديدة الدولية وأكاديمية الهلال، وشارك في تأسيس مدرسة الجيل الجديد الدولية وبنك طعام الهلال. كما شارك في عضوية مجلسي إدارة بنك الطعام المصري ومؤسسة أپليفت الخيرية.",
    en: "As a serial entrepreneur, he founded New Vision International School and Crescent Academy, and co‑founded New Generation International School and Crescent Food Bank. He has also served on the boards of the Egyptian Food Bank and UPLIFT Charity.",
  },
  biographyText3: {
    ar: "حاليًا هو السفير العالمي في مصر لجامعة كولورادو بولدر، ويُعد رسالة الماجستير في أصول الفقه في جامعة الأزهر، ورئيس شركة تطبيقات الهلال.",
    en: "Currently, he serves as CU Boulder's Global Ambassador, is pursuing a Master’s degree in the Principles of Islamic Jurisprudence at Al‑Azhar University, and is the president of Crescent Applications.",
  },
  profileHeading: {
    ar: "المعلومات الأساسية",
    en: "Personal Details",
  },
  nameAndBirth: {
    ar: "الاسم والميلاد",
    en: "Name & Birth",
  },
  name: {
    ar: "الاسم:",
    en: "Name:",
  },
  profileName: {
    ar: "شِهَابُ الدِّيْنِ أَبُو مَاجِدٍ أَحْمَدُ بْنُ مُحَمَّدٍ مَاجِدٍ آلُ الْجَمَلِ (الأُصُولِيُّ المَالِكِيُّ الأَزْهَرِيُّ)، الشهير بـ«الجمل».",
    en: "Ahmad El Gamal.",
  },
  birthDate: {
    ar: "تاريخ الميلاد:",
    en: "Date of Birth:",
  },
  profileBirthDate: {
    ar: "السبت ٣ شعبان عام ١٣٩٨هـ الموافق ٨ يوليو (تموز) ١٩٧٨م.",
    en: "Saturday, 3 Sha‘bān 1398 AH (8 July 1978 CE).",
  },
  birthPlace: {
    ar: "مكان الميلاد:",
    en: "Birth Place:",
  },
  profileBirthPlace: {
    ar: "قسم الدقي، محافظة الجيزة، مصر.",
    en: "Dokki, Giza, Egypt.",
  },
  family: {
    ar: "الأسرة",
    en: "Family",
  },
  siblings: {
    ar: "الإخوة:",
    en: "Siblings:",
  },
  siblingsText: {
    ar: "له أخ وأخت شقيقان وُلِدَا بعده.",
    en: "One younger brother and one younger sister.",
  },
  marriage: {
    ar: "الحالة الاجتماعية:",
    en: "Marital Status:",
  },
  marriageText: {
    ar: "متزوج، وله خمسة من الأولاد.",
    en: "Married, father of five.",
  },
  spouse: {
    ar: "الزوجة:",
    en: "Spouse:",
  },
  spouseText: {
    ar: "الدكتورة/ مي عبد المحسن - ربة منزل حاصلة على بكالوريوس طب الأسنان.",
    en: "Dr. May Abdelmohsen - family caretaker with a B.S. in Dentistry.",
  },
  citizenshipAndResidency: {
    ar: "الجنسية والإقامة",
    en: "Citizenship & Residency",
  },
  citizenship: {
    ar: "الجنسية:",
    en: "Citizenship:",
  },
  citizenshipText: {
    ar: "مصري - أمريكي.",
    en: "Egyptian‑American.",
  },
  currentResidence: {
    ar: "محل الإقامة الحالي:",
    en: "Current Residence: ",
  },
  currentResidenceText: {
    ar: "مدينة القاهرة الجديدة، محافظة القاهرة، مصر.",
    en: "New Cairo, Egypt.",
  },
  formerResidence: {
    ar: "محل الإقامة السابق:",
    en: "Former Residence: ",
  },
  formerResidenceText: {
    ar: "مدينة إيرڤاين، ولاية كاليفورنيا، أمريكا.",
    en: "Irvine, CA, USA.",
  },

  lineage: {
    ar: "النسب",
    en: "Lineage",
  },
  paternal: {
    ar: "حُسَيْنِيُّ الأب",
    en: "Ḥusaynī (Paternal Line)",
  },
  paternal1: {
    ar: "والده هو المهندس/ محمد ماجد الجمل - مهندس مدني ورجل أعمال.",
    en: "Father: Mohamed Maged El Gamal - civil engineer and businessman.",
  },
  paternal2: {
    ar: "جده لوالده هو المستشار/ محمد سعيد الجمل (رحمه الله تعالى) نائب رئيس محكمة استئناف الإسكندرية الأسبق.",
    en: "Paternal Grandfather: Judge Mohamed Saeed El Gamal (may God have mercy on him), former Vice President of the Alexandria Court of Appeal.",
  },
  paternal3: {
    ar: "طبقًا لما يتوارثه آل الجمل ويؤكده علم وكتب الأنساب فإن نسب آل الجمل يتصل بسيدنا النبي ﷺ من خلال الأئمة الاثنى عشر، فهو أحمد بن محمد ماجد بن محمد سعيد بن عبد العزيز بن عبد الفتاح بن مبروك بن مصطفى بن ابن محمد بن إبراهيم بن ابن أحمد الجمل بن عبد الواحد الجمل المغازي بن حسين الجمل المغازي بن علي الجمل الطحاوي (الملقب بـ«فارس الهيجة الحجازية») بن محمد المغازي (المعروف أيضًا باسم «محمد غازي») بن حسن العدل بن أحمد غازي (عم القطب    السيد أحمد البدوي) بن إبراهيم الأشهب (إبراهيم المغربي) بن محمد الأشهب بن أبي بكر الأشهب بن إسماعيل الأشهب بن عمر الأشهب (عمر المهابة) بن علي الأشهب بن عثمان الأشهب بن حسين الأشهب بن محمد الأشهب بن موسى الأشهب بن يحيى الهادي بن عيسى الهادي بن علي التقي بن الإمام محمد المهدي بن الإمام حسن العسكري بن الإمام علي الهادي بن الإمام محمد الجواد بن الإمام على الرضا بن الإمام موسى الكاظم بن الإمام جعفر الصادق بن الإمام محمد الباقر بن الإمام علي زين العابدين بن الإمام الحسين السبط بن الإمام علي بن أبي طالب (كرم الله وجهه) والسيدة فاطمة الزهراء بنت سيدنا محمد رسول الله ﷺ.",
    en: "Descent: The family traces its lineage to Imam al‑Ḥusayn ibn ‘Ali.",
  },
  maternal: {
    ar: "حَسَنِيُّ الأم",
    en: "Ḥasanī (Maternal Line)",
  },
  maternal1: {
    ar: "والدته هي السيدة/ پاكينام الرفاعي - ربة منزل حاصلة على بكالوريوس علوم في الكيمياء.",
    en: "Mother: Pakinam El Rifaie - family caretaker with a B.S. in Chemistry.",
  },
  maternal2: {
    ar: "جده لوالدته هو المستشار/ يحيى الرفاعي (رحمه الله تعالى) نائب رئيس محكمة النقض الأسبق، ورئيس نادي القضاة الأسبق، الملقب بـ«شيخ القضاة العرب»، ومؤسس «تيار استقلال القضاء».",
    en: "Maternal Grandfather: Judge Yahia El Rifaie (may God have mercy on him), former Vice President Egypt's Court of Cassation and President of the Judges' Club. Honored as 'the Shaykh of Arab Judges,' he founded the 'Judicial Independence Movement'.",
  },
  maternal3: {
    ar: "بحسب ما هو مدون بنقابة السادة الأشراف في مصر، التي يشرف بعضويتها أحمد الجمل، فإن نسب آل الرفاعي يتصل بسيدنا النبي ﷺ من خلال الإمام الحسن (رضي الله عنه)، فوالدته هي پاكينام بنت يحيى بن عبد اللطيف بن أحمد بن محمد بن مصطفى بن الرفاعي بن محمد بن نصر الدين بن عبد الحق بن نصر الدين بن محمد من ذرية نصر الدين الأزهري بن أحمد بن مرزوق بن سليمان بن إبراهيم بن عبد الرحمن غازي بن سيدي مرزوق الكفافي بن موسى بن منصور بن علي بن إبراهيم بن أحمد بن موسى بن عبد الله بن موسى الجَوْن بن عبد الله الكامل بن الإمام الحسن المثنى بن الإمام الحسن السبط بن الإمام علي بن أبي طالب والسيدة فاطمة الزهراء بنت سيدنا محمد رسول الله ﷺ.",
    en: "Descent: The family traces its lineage to Imam al‑Ḥasan ibn ‘Ali.",
  },

  studies: {
    ar: "الدراسة",
    en: "Education",
  },
  religiousEducation: {
    ar: "علوم الدين",
    en: "Religious Education",
  },
  masters: {
    ar: "",
    en: "Uṣūl al‑Fiqh",
  },
  rE1A: {
    ar: " في عام ٢٠٢٥م أنهى مرحلة تمهيدي الماجستير في أصول الفقه (بتقدير جيد جدًا) بكلية العلوم الإسلامية والعربية للوافدين ",
    en: "2025: Completed the Pre‑Master's Program in the Fundamentals of Jurisprudence at",
  },
  rE1Link: {
    ar: "بجامعة الأزهر",
    en: "Al‑Azhar University",
  },

  rE2A: {
    ar: "في عام ٢٠٢٢م حصل على درجة الإجازة العالية (الليسانس) في العلوم الإسلامية والعربية --تعليم عن بعد-- (بتقدير جيد جدًا) من كلية العلوم الإسلامية والعربية للوافدين",
    en: "2022: Earned a B.A. in Islamic and Arabic Sciences from the E‑Learning Center at",
  },
  rE2Link: {
    ar: "بجامعة الأزهر",
    en: "Al‑Azhar University",
  },

  rE3: {
    ar: "في عام ٢٠١٨م نال الإجازة في قراءة القرآن الكريم برواية حفص عن عاصم الكوفي، من طريق الشاطبية، من شيخه هيثم المناوي.",
    en: "2018: Received Ijāzah (formal certification) in the Qur’anic narration of Ḥafṣ ʿan ʿĀṣim via al‑Shāṭibiyyah from his teacher, Shaykh Haitham El‑Menawy.",
  },
  rE4A: {
    ar: "في عام ٢٠١٤م حصل على أول شهادة في القيادة الإسلامية تعتمدها ",
    en: "2014: Earned the inaugural Certificate in Islamic Leadership by",
  },
  rE4Link: {
    ar: "كلية بيان",
    en: "Bayan Claremont",
  },
  rE4B: {
    ar: " في كاليفورنيا، بعد إتمام مواد دراسية بمستوى الدراسات العليا.",
    en: ", in California, after completing a series of graduate‑level courses.",
  },

  secularEducation: {
    ar: "علوم الدنيا",
    en: "Secular Education",
  },
  sE1A: {
    ar: "في عام ٢٠٢١م حصل على شهادة تطوير تطبيقات شبكة المعلومات (الإنترنت) (بتقدير ممتاز) من",
    en: "2021: Earned a Full‑Stack Web Development Certificate from the",
  },
  sE1Link: {
    ar: "جامعة كاليفورنيا بركلي",
    en: "University of California Berkeley (UC Berkeley) Extension",
  },
  sE1B: {
    ar: "بعد إتمام برنامج تدريبي مكثف لمدة ستة أشهر.",
    en: "after completing a six-month intensive bootcamp.",
  },
  sE2A: {
    ar: "في عام ١٩٩٩م حصل على درجة بكالوريوس العلوم في الهندسة المدنية (بتقدير جيد جدًا) من",
    en: "1999: Received a B.S. in Civil Engineering from the",
  },
  sE2Link: {
    ar: "جامعة كولورادو بولدر",
    en: "University of Colorado Boulder (CU Boulder)",
  },

  sE3A: {
    ar: "في عام ١٩٩٤م حصل على الشهادة الثانوية الدولية ",
    en: "1994: Earned the International General Certificate of Secondary Education ",
  },
  sE3B: {
    ar: " من جامعة كامبريدج البريطانية (مع مرتبة التميز: ",
    en: " from the University of Cambridge with ",
  },
  sE3C: {
    ar: ") وهو في الخامسة عشرة من عمره - ليكون من أصغر الخريجين في دفعته.",
    en: " at age fifteen - among the youngest in his cohort.",
  },
  sE4A: {
    ar: "كما حضر العديد من الدورات والورش في مجالات إدارة الأعمال والتربية والتعليم وبرمجة الحاسوب وغيرها من العلوم في أماكن متعددة، منها معهد إعداد القادة،",
    en: "Completed numerous courses and workshops in business, education, computer science, and related fields at multiple institutions, including the Private Sector Development Program (PSDP),",
  },
  sE4Link1: {
    ar: "مركز لوجيك",
    en: "LOGIC Consulting Group",
  },
  sE4Link2: {
    ar: "الجامعة الأمريكية بالقاهرة",
    en: "The American University in Cairo (AUC)",
  },
  sE4Link3: {
    ar: "جامعة كاليفورنيا في إيرڤاين",
    en: "The University of California Irvine (UC Irvine)",
  },

  workExperience: {
    ar: "الخبرة المهنية",
    en: "Work Experience",
  },
  softwareDevelopment: {
    ar: "تطوير البرامج",
    en: "Software Development",
  },
  sD1A: {
    ar: "الرئيس المؤسس، شركة",
    en: "Founding President,",
  },
  sD1B: {
    ar: "تطبيقات الهلال",
    en: "Crescent Applications",
  },
  sD1C: {
    ar: "لتطوير البرامج",
    en: "(software development firm)",
  },
  sD2A: {
    ar: "منتج، تطبيق",
    en: "Producer,",
  },
  sD2B: {
    ar: "الذي أُتيح مجانًا على متجر تطبيقات أپل",
    en: "- a free Quran application that was available on the App Store",
  },
  sD3A: {
    ar: "مصمم ومطور، عدة تطبيقات في مجالات مختلفة",
    en: "Lead Architect, multiple web applications in diverse sectors",
  },
  education: {
    ar: "التعليم",
    en: "Education",
  },
  foundingPresident: {
    ar: "الرئيس المؤسس،",
    en: "Founding President,",
  },
  nvc: {
    ar: "شركة الرؤية الجديدة للإنشاءات",
    en: "New Vision Construction",
  },
  ed1B: {
    ar: "أكاديمية الهلال",
    en: "Crescent Academy",
  },
  ed1C: {
    ar: "(مركز تعليمي)",
    en: "(after‑school learning center)",
  },
  ed2A: {
    ar: "رئيس مجلس الإدارة المؤسس،",
    en: "Founding Chairman,",
  },
  ed2B: {
    ar: "مدرسة الرؤية الجديدة الدولية",
    en: "New Vision International School",
  },
  ed2C: {
    ar: "(الجيزة)",
    en: "(Giza)",
  },
  ed3A: {
    ar: "الشريك المؤسس،",
    en: "Co-Founding General Manager,",
  },
  ed3B: {
    ar: "مدرسة الجيل الجديد الدولية",
    en: "New Generation International School",
  },
  ed3C: {
    ar: "(القاهرة)",
    en: "(Cairo)",
  },
  construction: {
    ar: "الإنشاء",
    en: "Construction",
  },
  cn3A: {
    ar: "عضو مجلس الإدارة، شركة بريمير المالكة والمطورة لمنتجع",
    en: "Board Member, Premier - owner/developer of",
  },
  cn3B: {
    ar: "طابا پارادايس",
    en: "Taba Paradise",
  },
  cn3C: {
    ar: "السياحي (طابا، مصر)",
    en: "(five‑star resort in Taba, Egypt)",
  },
  cn2A: {
    ar: "مهندس مدني، مجمع",
    en: "Civil Engineer,",
  },
  cn2B: {
    ar: "جوهرة الشروق",
    en: "Gawharet El‑Shorouk",
  },
  cn2C: {
    ar: "الإسكاني (مدينة الشروق، مصر)",
    en: "- a residential community in El-Shorouk City",
  },
  cn1A: {
    ar: "المقاول العام، المرحلة الأولى من",
    en: "General Contractor, Phase 1 of",
  },
  cn1B: {
    ar: "مدرسة الرؤية الجديدة الدولية",
    en: "New Vision International School",
  },
  cn1C: {
    ar: "وبعض المشاريع الأخرى صغيرة الحجم",
    en: "and other small‑scale projects",
  },
  other: {
    ar: "الأنشطة تجارية",
    en: "Retail & Commerce",
  },
  ot1A: {
    ar: "الرئيس المؤسس، شركة كرسنت تريد، الموزع الحصري (سابقًا) لمنتجات",
    en: "Founding President, Crescent Trade, former Sole Distributor of",
  },
  ot1B: {
    ar: "لايفتايم",
    en: "Lifetime Products",
  },
  ot1C: {
    ar: "الأمريكية، وصانعة كتيب",
    en: "and creator of",
  },
  ot1D: {
    ar: "دليلك",
    en: "Daleelak",
  },
  ot1E: {
    ar: "للدعاية والخصومات (مصر)",
    en: "(coupon/discount booklet) (Egypt)",
  },
  ot2A: {
    ar: "الرئيس المؤسس، شركة كرسنت هولدنجز، صانعة",
    en: "Founding President, Crescent Holdings, creator of",
  },
  ot2B: {
    ar: "كرسنت بوتيك",
    en: "Crescent Boutique",
  },
  ot2C: {
    ar: " - علامة تجارية لملابس المحجبات (جنوب كاليفورنيا)",
    en: " - Islamic women's fashion brand (Southern California)",
  },
  ot3A: {
    ar: "مؤسس، كتيب",
    en: "Founder,",
  },
  ot3C: {
    ar: "للدعاية والخصومات (مصر)",
    en: "- coupon and discount booklet (Egypt)",
  },

  volunteering: {
    ar: "العمل التطوعي",
    en: "Volunteering",
  },
  currently: {
    ar: "حاليًا",
    en: "Current Roles",
  },
  currently1a: {
    ar: "سفير عالمي،",
    en: "Global Ambassador,",
  },
  currently1link: {
    ar: "جامعة كولورادو بولدر",
    en: "CU Boulder",
  },
  previously: {
    ar: "سابقًا",
    en: "Former Roles",
  },
  previously1A: {
    ar: "سفير إقليمي، رابطة خريجي كلية الهندسة والعلوم التطبيقية،",
    en: "Regional Network Ambassador, College of Engineering & Applied Sciences Alumni Network,",
  },
  previously1link: {
    ar: "جامعة كولورادو بولدر",
    en: "CU Boulder",
  },
  previously1B: {
    ar: "(جنوب كاليفورنيا)",
    en: "(Southern California)",
  },

  previouslyCcA: {
    ar: "القائد المؤسس، نادي الهلال،",
    en: "Founding Leader, Crescent Club,",
  },
  previouslyCcLink: {
    ar: "The Great Park Neighborhoods (GPN)",
    en: "The Great Park Neighborhoods (GPN)",
  },
  previouslyCcB: {
    ar: "(جنوب كاليفورنيا).",
    en: "(Southern California).",
  },
  previously3a: {
    ar: "مؤسس ورئيس مجلس إدارة،",
    en: "Chairman & Co‑Founder,",
  },
  previously3b: {
    ar: "بنك طعام الهلال",
    en: "Crescent Food Bank",
  },
  previously3c: {
    ar: "(جنوب كاليفورنيا).",
    en: "(Southern California).",
  },

  previously6a: {
    ar: "عضو مجلس إدارة، جمعية",
    en: "Board Member,",
  },
  previously6b: {
    ar: "UPLIFT",
    en: "UPLIFT Charity",
  },
  previously6c: {
    ar: "الخيرية (جنوب كاليفورنيا).",
    en: "(Southern California).",
  },
  previously7a: {
    ar: "عضو مجلس إدارة،",
    en: "Board Member,",
  },
  previously7b: {
    ar: "بنك الطعام المصري",
    en: "Egyptian Food Bank",
  },
};

export default AboutAhmadLocales;
